const base = "cui-tab-tkus";
const classes = {
  base
};
export {
  base,
  classes as default
};
